import { Component, Input, ViewChild, OnChanges } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { CommonService } from '../../services/common.service'; 

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html'
})
export class ConfirmComponent implements OnChanges {

  @ViewChild('confirmModal') public confirmModal: ModalDirective;
  @Input() modalInfo: any;

  constructor(
    public commonService: CommonService
  ) {
  }

  ngOnChanges() {
    if(this.modalInfo.present) {
      this.confirmModal.show();
    }
  }

  confirmIt() {
    this.commonService.confirmReturn.emit(true);
    this.confirmModal.hide();
  }
  
  closeIt() {
    this.commonService.confirmReturn.emit(false);
    this.confirmModal.hide();
  }
}
